import service from "@irati/utils/tracking/index"

const TRACKING_ROOT = "contentCard"

class ContentCardsTracking {

  viewContentCards = (params?: any) => {
    service.trackPlatformEvent(`${TRACKING_ROOT}_view`, params)
  }

  clickContentCard = (params?: any) => {
    service.trackPlatformEvent(`${TRACKING_ROOT}_click`, params)
  }
}

const contentCardsTracking = new ContentCardsTracking()

export default contentCardsTracking
